/**
 * Domain service: pure simulation rules (TOGAF Simulation context)
 */
import type { Grid, CityStats, ResearchState } from '../../../types';
import type { TickResult } from '../types/tickResult';
import { createInitialGrid } from './gridFactory';
import { calculateConnectivity } from './connectivity';
import { checkZoneViolations } from './complianceRules';
import { checkScenarioObjective } from './scenarioEvaluator';
import { calculateTickMetrics } from './tickCalculator';

export type { TickResult } from '../types/tickResult';
export { checkZoneViolations } from './complianceRules';
export { calculateConnectivity } from './connectivity';
export { createInitialGrid } from './gridFactory';
export { checkScenarioObjective } from './scenarioEvaluator';
export { calculateTickMetrics } from './tickCalculator';

export class SimulationEngine {
  createInitialGrid(): Grid {
    return createInitialGrid();
  }

  calculateConnectivity(grid: Grid): Grid {
    return calculateConnectivity(grid);
  }

  checkZoneViolations(grid: Grid) {
    return checkZoneViolations(grid);
  }

  checkScenarioObjective(
    desc: string,
    stats: CityStats,
    counts: Record<string, number>,
    research?: ResearchState,
    violationCount?: number
  ): boolean {
    return checkScenarioObjective(desc, stats, counts, research, violationCount);
  }

  calculateTickMetrics(grid: Grid, stats: CityStats, tickNumber: number): TickResult {
    return calculateTickMetrics(grid, stats, tickNumber);
  }
}

export const simulationEngine = new SimulationEngine();